import { action, computed, observable } from 'mobx';

import { toJSON } from 'evite';
const indexes = {};

export default class Collection {
  //get model() {return Model };
  @observable models = [];


  constructor(models = [], options = {model: null}) {
    models = models || [];
    options = options || {};

    if(!this.model && options.model) {
      this.model = options.model;
    }

    this.reset(models, options);
  }


  parse(list) {
    const Model = this.model;
    list = list || [];
    let length = list.length;

    let modelList = [];

    for(let i = 0; i < length; ++i) {
      let data = list[i];
      const isModel = data instanceof Model;
      const model = isModel? data: new Model(toJSON(data));
      modelList.push(model);
    }

    return modelList;
  }

  reset(list) {
    if (list && list.length) {
      let newModels = this.parse(list);
      this.replace(newModels);
    } else {
      this.replace([]);
    }
  }

  @action append(list) {
    list = Array.isArray(list)? list: Array.from(arguments);
    this.models.push.apply(this.models, list);
  }

  findWhere(props){
    const index = this.findIndexWhere(props);
    if(index === -1){
      return null;
    }

    return this.models[index];
  }

  findIndexWhere(props){
    let modelList = this.models;
    for(let i = 0; i < modelList.length; ++i){
      let model = modelList[i];
      let isMatch = true;
      for(let key in props){
        if(props[key] !== model[key]){
          isMatch = false;
          break;
        }
      }

      if(isMatch){
        return i;
      }
    }

    return -1;
  }

  toJSON() {
    return toJSON(this.models);
  }

  @computed get length() {
    return this.models.length;
  }
};

[
  'clear',
  'concat',
  'every',
  'filter',
  'find',
  'findIndex',
  'forEach',
  'get',
  'indexOf',
  'intercept',
  'join',
  'lastIndexOf',
  'map',
  'move',
  'peek',
  'observe',
  'peek',
  'pop',
  'push',
  'reduce',
  'reduceRight',
  'remove',
  'replace',
  'reverse',
  'shift',
  'slice',
  'some',
  'sort',
  'splice',
  'spliceWithArray',
  'unshift'
].forEach(function (key) {
  if (Collection.prototype[key]) {
    return;
  }

  Collection.prototype[key] = action(key, function () {
    const args = Array.from(arguments);
    return this.models[key].apply(this.models, args);
  });
});

for(let i = 0; i < 1000; ++i) {
  indexes[i] = undefined;
  (function (index) {
    Object.defineProperty(Collection.prototype, index, {
      get: function () {
        return this.models[index];
      },
      set: action(function (value) {
        this.models[index] = value;
      })
    });
  })(i);
}



// WEBPACK FOOTER //
// ./assets/es6/common/collections/collection.es6